import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import ShopList from '../../../components/shopList';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { eduTitle, eduList0, shopInHealth, homeList, eduRSAd, replaceShopConfig2 },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="260706" type="struct" title="教育和家居标题" groupName="教育和家居" content={eduTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="287961"
                    type="recommend"
                    title="美好中国"
                    groupName="教育"
                    content={eduList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="short" />
                </Chip>
                {replaceShopConfig2.isShow ? (
                    <NoSSR>
                        <Ad content={eduRSAd} styleName={styles.adBox} />
                    </NoSSR>
                ) : (
                    <ShopList size="short" content={shopInHealth} sourceName="shopInHealth" />
                )}
                <Chip
                    id="287962"
                    type="recommend"
                    title="教育"
                    groupName="教育"
                    content={homeList}
                    translate="handleNewsData">
                    <NewsList size="short" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
